import { render, staticRenderFns } from "./modal-warning.vue?vue&type=template&id=38704e36&scoped=true"
import script from "./modal-warning.vue?vue&type=script&lang=js"
export * from "./modal-warning.vue?vue&type=script&lang=js"
import style0 from "./modal-warning.vue?vue&type=style&index=0&id=38704e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38704e36",
  null
  
)

export default component.exports